// 섹션 이름과 라우트 매핑
export const SECTION_ROUTE_MAP = {
    '비전': {
        route: '/vision',
        icon: '🎯',
        subtitle: 'Vision',
        description: '목표와 미래를 함께 만들어갑니다',
        color: '#ffffff',
        gradient: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
    },
    '인정': {
        route: '/recognition',
        icon: '⭐',
        subtitle: 'Recognition',
        description: '당신의 노력과 성과를 인정합니다',
        color: '#e5e5e5',
        gradient: 'linear-gradient(135deg, #2d2d2d 0%, #404040 100%)',
    },
    '보상': {
        route: '/reward',
        icon: '🏆',
        subtitle: 'Reward',
        description: '공정한 평가와 보상 시스템',
        color: '#cccccc',
        gradient: 'linear-gradient(135deg, #404040 0%, #525252 100%)',
    },
    '교육': {
        route: '/education',
        icon: '📚',
        subtitle: 'Education',
        description: '지속적인 성장을 위한 학습 기회',
        color: '#b3b3b3',
        gradient: 'linear-gradient(135deg, #525252 0%, #666666 100%)',
    }
};

// 라우트에서 섹션 이름으로 역매핑
export const ROUTE_SECTION_MAP = {
    '/vision': '비전',
    '/recognition': '인정',
    '/reward': '보상',
    '/education': '교육'
};

// 라우트로 섹션 이름 가져오기
export const getSectionNameByRoute = (route) => {
    return ROUTE_SECTION_MAP[route] || null;
};

// 섹션 이름으로 라우트 정보 가져오기
export const getRouteInfoBySection = (sectionName) => {
    return SECTION_ROUTE_MAP[sectionName] || null;
};
